import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/wishcard/address.png';
import _imports_1 from '../../assets/img/wishcard/comment.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-08ae5e29"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hr"
  }, null, -1);
});

var _hoisted_2 = {
  class: "detail"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "richText"
};
var _hoisted_5 = {
  class: "location"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "left",
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_7 = {
  class: "right"
};
var _hoisted_8 = {
  class: "time"
};
var _hoisted_9 = {
  key: 0,
  class: "detalImg"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hr"
  }, null, -1);
});

var _hoisted_11 = {
  class: "record"
};
var _hoisted_12 = {
  class: "block handle"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "block_title"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "red"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "redRight"
  }, " 备注 "), /*#__PURE__*/_createElementVNode("div", {
    class: "photo"
  }, " 最多可上传9张图片 ")], -1);
});

var _hoisted_14 = {
  class: "relat"
};
var _hoisted_15 = {
  key: 0,
  class: "relativeImg",
  src: _imports_1
};
var _hoisted_16 = {
  class: "footer"
};

var _hoisted_17 = /*#__PURE__*/_createTextVNode(" 打卡 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_previewImg = _resolveComponent("previewImg");

  var _component_el_input = _resolveComponent("el-input");

  var _component_UpLoadImg = _resolveComponent("UpLoadImg");

  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "心愿详情",
    back: true
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Data.detail.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.Data.detail.richText), 1), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.Data.detail.location), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.Data.detail.wishEndTime), 1), _ctx.Data.detail.imgUrls ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_previewImg, {
    width: "180rpx",
    height: "180rpx",
    list: _ctx.Data.detail.imgUrls
  }, null, 8, ["list"])])) : _createCommentVNode("", true), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_input, {
    modelValue: _ctx.Data.form.comment,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.Data.form.comment = $event;
    }),
    rows: 3,
    maxlength: "100",
    "show-word-limit": "",
    type: "textarea",
    placeholder: "请填写备注",
    resize: "none",
    onFocus: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.Data.show = false;
    })
  }, null, 8, ["modelValue"]), _ctx.Data.form.comment == '' && _ctx.Data.show ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(_component_UpLoadImg, {
    ref: "uploadRef",
    limit: 9,
    class: "upLoadImg",
    onFile: _ctx.Imgchange
  }, null, 8, ["onFile"])])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
    class: "btn",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.operation(_ctx.Data.detail.id);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_17];
    }),
    _: 1
  })])])])], 64);
}